import { useEffect, useState } from "react";

const TABLET_LAYOUT_MEDIA = "(min-width: 769px) and (max-width: 1200px)";

const useTabletLayout = () => {
  const [isTablet, setIsTablet] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(TABLET_LAYOUT_MEDIA).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(TABLET_LAYOUT_MEDIA);
    const onChange = () => setIsTablet(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return isTablet;
};

export default useTabletLayout;
